import { LoginType } from "@/shared/constants/enum";
import { User } from "@/shared/types/user";
import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

type userState = {
  user: User | null;
  accountType: LoginType;
};

type AuthAction = {
  setUser: (user: User) => void;
  setAccountType: (accountType: LoginType) => void;
  clearUserStore: () => void;
};

const initialUser: userState = {
  user: null,
  accountType: LoginType.MOODLE,
};

export const useUserStore = create<userState & AuthAction>()(
  persist(
    (set) => ({
      ...initialUser,
      setUser: (user: User) => set(() => ({ user })),
      setAccountType: (accountType: LoginType) => set(() => ({ accountType })),
      clearUserStore: () => set({ ...initialUser }),
    }),
    {
      name: "user-store",
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);
